export default {
  // 风险评估
  assessment: {
    entry: {
      pageTitle: "Risk tolerance assessment",
      riskText: "Test your risk tolerance",
      btnText: "Begin evaluation"
    },
    question: {
      pageTitle: "Risk tolerance questionnaire",
      btnText: "Submit assessment",
      titleText: "Please choose according to your actual situation",
      titleMark: "*Required",
      derivative_clew: "Inconsistent with ID card, please confirm",
      derivative_clew_two:
        "Inconsistent with the appropriateness survey, please confirm",
      question: [
        {
          id: 1,
          title: "Your age is between？",
          isMust: true,
          choices: [
            {
              text: "(a) Between the ages of 18 and 35",
              name: "a"
            },
            {
              text: "(b) Between the ages of 36 and 44",
              name: "b"
            },
            {
              text: "(c) Between the ages of 44 and 55",
              name: "c"
            },
            {
              text: "(d) Between the ages of 55 and 65",
              name: "d"
            },
            {
              text: "(e) 65 one full year of life",
              name: "e"
            }
          ]
        },
        {
          id: 2,
          title: "What is your education level？",
          isMust: true,
          choices: [
            {
              text: "(a) Primary level or below",
              name: "a"
            },
            {
              text: "(b) Secondary level",
              name: "b"
            },
            {
              text: "(c) Non-degree tertiary",
              name: "c"
            },
            {
              text: "(d) University or above level",
              name: "d"
            }
          ]
        },
        {
          id: 3,
          title:
            "Do you have any investment experience or knowledge of the below products? (You may select more than 1 option)？",
          isMust: true,
          isCheck: true,
          ref: "checkBoxRef1",
          choices: [
            {
              text:
                "(a) Cash, Deposits, Certificates of Deposit, Capital Protected Products, HKSAR Government Bond, Mandatory Provident Funds,   Money Market Funds",
              name: "a"
            },
            {
              text:
                "(b) Stocks, Bonds, Equity or Bond Funds (including Mandatory Provident Funds, but excluding money market funds),     investment-linked insurance plans",
              name: "b"
            },
            {
              text:
                "(c) Derivatives (Options, futures, warrants), hedge funds and other Structured products (e.g. accumulators, equity-linked deposit/notes)",
              name: "c"
            }
          ]
        },
        {
          id: 4,
          title:
            "How many years of experience do you have with following investment products (including foreign currencies, commodities, structured investment products, warrants, options or futures) that the value can fluctuate (when either ‘buy and hold’ or active trading)？",
          isMust: true,
          choices: [
            {
              text: "(a) No experience",
              name: "a"
            },
            {
              text: "(b) Less than 1 year",
              name: "b"
            },
            {
              text: "(c) Between 1 and 3 years",
              name: "c"
            },
            {
              text: "(d) Over 3 years",
              name: "d"
            }
          ]
        },
        {
          id: 5,
          title:
            "How many years of experience do you have with following investment products (including stocks, unit trusts, investment-linked insurance plans, bonds) that the value can fluctuate (when either ‘buy and hold’ and/or active trading)？",
          isMust: true,
          choices: [
            {
              text: "(a) No experience",
              name: "a"
            },
            {
              text: "(b) Less than 1 year",
              name: "b"
            },
            {
              text: "(c) Between 1 and 3 years",
              name: "c"
            },
            {
              text: "(d) Over 3 years",
              name: "d"
            }
          ]
        },
        {
          id: 6,
          preTitle:
            "Over a period of time the value of investments can rise and fall, this is called fluctuation. Generally, the higher the investment risk the higher the potential fluctuation but also the higher the potential returns. On the other hand, the lower the investment risk the lower the potential fluctuation but also the lower the potential returns. ",
          title:
            "What level of fluctuation would you generally be comfortable with？",
          isMust: true,
          choices: [
            {
              text: "(a) Fluctuates under -30% and over +30%",
              name: "a"
            },
            {
              text: "(b) Fluctuates between -25% and +25%",
              name: "b"
            },
            {
              text: "(c) Fluctuates between -15% and +15%",
              name: "c"
            },
            {
              text: "(d) Fluctuates between -5% and +5%",
              name: "d"
            }
          ]
        },
        {
          id: 7,
          title:
            "Approximately what percentage of your net liquid assets (excluding self-use properties) do you intent to invest through Going Securities？",
          isMust: true,
          choices: [
            {
              text: "(a) Less than 10%",
              name: "a"
            },
            {
              text: "(b) 10% ~ 40%",
              name: "b"
            },
            {
              text: "(c) 40% ~ 60%",
              name: "c"
            },
            {
              text: "(d) 60% or above",
              name: "d"
            }
          ]
        },
        {
          id: 8,
          title:
            "How much of your investments would require to liquidate to meet liquidity need for an unforeseen event？",
          isMust: true,
          choices: [
            {
              text: "(a) I would not have to sell any of any my investments",
              name: "a"
            },
            {
              text: "(b) I would sell no more than 30% of my investments",
              name: "b"
            },
            {
              text:
                "(c) I would sell more than 30% but less than 50% of my investments",
              name: "c"
            },
            {
              text: "(d) I would sell more than 50% of my investments",
              name: "d"
            }
          ]
        },
        {
          id: 9,
          preTitle:
            "It is generally true that the longer the investment horizon, the higher the risk an investor can tolerate, and the values of investment products will fluctuate.",
          title:
            "What time horizon would you generally be comfortable with when investing in investment product？",
          posTitle: "Please refer to Question 3 for examples of such products",
          isMust: true,
          choices: [
            {
              text: "(a) Over 5 years",
              name: "a"
            },
            {
              text: "(b) Between 3 and 5 years",
              name: "b"
            },
            {
              text: "(c) Between 1 and 3 years",
              name: "c"
            },
            {
              text: "(d) Less than 1 year",
              name: "d"
            }
          ]
        },
        {
          id: 10,
          title:
            "Which of the following choices best describes your investment objective？",
          isMust: true,
          choices: [
            {
              text:
                "(a) Defensive — I aim to protect my capital and receive returns slightly higher than bank deposits, and I can tolerate minimal capital loss.",
              name: "a"
            },
            {
              text:
                "(b) Income — I aim a balance of regular income and capital growth, and I can tolerate moderate capital loss.",
              name: "b"
            },
            {
              text:
                "(c) Capital Grain — I aim stable capital appreciation over a longer time, and I can tolerate high capital loss.",
              name: "c"
            },
            {
              text:
                "(d) Aggressive — I aim only capital appreciation, and I can tolerate substantial fluctuations in capital value. I am willing to take higher risks for significantly higher returns over time.",
              name: "d"
            }
          ]
        }
      ],
      toastMsg: "Please choose according to your actual situation"
    },
    result: {
      pageTitle: "Risk tolerance assessment",
      domText: [
        "Your score is",
        "points",
        "Total of 100 points",
        "You belong to",
        "investors",
        "Risk Tolerance:",
        "Determine",
        "To measure",
        "Disclaimer and customer statement",
        "Please read the following statement and click the button at the bottom of the popover",
        "I have read the disclaimer and agree with the customer statement",
        "Don't agree with"
      ],
      textContent: [
        {
          title: "Disclaimer",
          content: [
            "1. The results of this questionnaire are derived from the information that you have provided to Going Securities Limited and on certain generally accepted assumptions and reasonable estimate. Calculations and values used in this questionnaire are used for illustration purpose only. Going Securities accepts no responsibility or liability as to the accuracy or completeness of the information containing in this questionnaire and/or the results.",
            "2. This questionnaire and the results only serve as a reference for your consideration, and are not an offer to sell or a solicitation for an offer to buy any financial products and services and they should not be considered as investment advice or recommendation.",
            "3. Please be reminded that any failure to fully disclose all or any of your personal circumstances (e.g. financial situation), inaccurate, incomplete or outdated information may affect our assessment of your attitude and capacity for investment risks. If there is any change in circumstances which may affect your answer(s) to any question in this questionnaire. We strongly recommended that you should complete this questionnaire again."
          ]
        },
        {
          title: "DECLARATION BY CLIENT",
          content: [
            "I hereby declare that the information I have provided in this form is in all respects true, accurate and complete and agree that my investment risk tolerance analysis is correctly stated above."
          ]
        }
      ]
    }
  },
  // 资金管理
  funds: {
    pageTitle: [
      "Capital account",
      "Details of account amount",
      "Deposit",
      "Remittance reference information",
      "Upload remittance voucher",
      "Details",
      "List of fund accounts",
      "Record of fund transfer",
	  "Fund transfer"
    ],
    domText: [
      "Futures account",
      "CFD account",
      "Reduce",
      " currency",
      "Total transferable amounts",
      "Transferable funds",
      "Total account amount",
      "Balance",
      "My bank card",
      "Record of amount",
      "Flow records of amount",
      " currency",
    ],
    copy: "Futures account number copied successfully",
    copyFail: "Futures account number copy failed",
	accountName:["Futures account","Securities account"], 
    jsText: ["Binded", "Unbind"],
    btnText: ["Deposit", "Withdraw", "Swap", "Account details"],
    currencyText: ["USD", "HKD", "CNH"],
    orderDetail: {
      domText: ["Transfer Voucher", "Note", "Failed refund"],
      fieldsText: [
        "No.",
        "Account",
        "Type",
        "Business Type",
        "Result",
        "Currency",
        "Currency",
        "Amount",
        "Amount",
        "Sumbit Time",
        "Sumbit Time",
        "Fees",
        "Arrival Amount",
        "Estimated Arrival Amount",
        "Arrival Time"
      ],
      otherText: ["Payment currency", "Payment amount", "Payment time"],
      payText: ["Remittance", "Cash Transfer", "Entry by staff", "Exchange", "Information Order"]
    },
    fundsDetail: {
      domText: "Update time",
      fieldsText: [
        "Account name",
        "Account type",
        "Accounts",
        "USD account",
        "Available in USD account",
        "HKD account",
        "Available in HKD account",
        "CNH account",
        "Available in CNH account"
      ]
    },
    into: {
      domText: [
        "My bank card",
        "Please do not use another person's bank account for remittance The remitter and the futures account holder must be the same person.",
        "Note that according to the requirements of the SFC, the remitter and the securities and futures account holder must be the same person. The name of the bank account must be the same as that of your GAO Ying International Hong Kong account.",
        "Step 1: Prepare HKD",
        "Please make sure that you have Hong Kong dollars in your bank account. You can convert them into Hong Kong dollars through online banking or mobile banking",
        "Step 2: Transfer to HKD",
        "Please remit the money to the bank account designated below. It is recommended to use the Industrial and Commercial Bank of China, Huaxia Bank, for remittance with a high success rate. China Merchants Bank, Bank of Communications, Construction Bank of the mainland is temporarily unable to use the transfer.",
        "To ensure the safety of your funds, please immediately after the remittance.",
        "Take a screen capture and upload the remittance voucher",
        "Please upload one or more screenshots with specific remittance amount when transferring money in mobile bank. The voucher must include the name of the remitter, the beneficiary's account and the beneficiary's name",
        "Please remit the money to your ICBC Asia Escrow account",
        'Put "GoingInternational" in front of your name in all capital letters.',
        "Your escrow account is encrypted by default to hide view please click the button",
        "Please select remittance bank",
        "Disposit guide",
        "Fill out the remittance form according to the following information",
        "Free of charge",
        "Estimated arrival time within 1~3 working days"
      ],
      bankList: [
        "China inland Bank Cards",
        "Bank Cards in Hong Kong",
        "Support for HKD and USD",
        "Support for HKD、USD and CNH"
      ],
      fieldsText: [
        "Name of payee",
        "Receiving account",
        "National / Area",
        "Address of payee",
        "Receiving Bank (Chinese)",
        "Receiving Bank (English)",
        "Bank address",
        "Bank name",
        "Account name",
        "Receiving account (HKD)",
        "Receiving account (USD)",
        "Receiving account (CNH)"
      ],
      others: [
        "Copy",
        "Check",
        "Remitted , to upload the voucher",
        "Application successful",
        "Got it",
        "Your application has been received and will be processed within 1 business day",
        "Replication Success"
      ],
      tips: [
        "Attention：",
        "For the safety of your funds, please take a screenshot and upload the remittance voucher immediately after remittance；",
        "When making a mobile bank transfer, please upload one or more screenshots of the page with the exact amount of the transfer；",
        "The certificate needs to contain the amount of the remittance remitter's name and the name of the recipient's account number",
        "Tip: Please provide relevant vouchers according to the actual situation to help us provide you with better service and experience"
      ]
    },
    credential: {
      domText: [
        "Complete and upload the remittance voucher",
        "Submit",
        "CNH",
        "Fill in amount，less than 2 decimals",
        "Uploading",
        "Funds transfer order submission successful",
        "1-3 working days estimated time for payment",
        "Got it"
      ],
      fields: [
        "Currency of remittance",
        "Amount deposited",
        "Upload credentials",
        "Please upload the selected voucher"
      ]
    },
    transferRecord:{
      domText:['cancellation of order','Please enter the transaction password','Forgot the transaction password?','Do you want to cancel the fund transfer order?','Please enter the transaction password',
      'The order was successfully cancelled','reminder','Not canceled temporarily','determine','Verify transaction password'],
      fields:['Pending processing','Successfully processed','Processing failed','Order cancellation']
    }
  },
  // 银行卡
  bankCard: {
    pageTitle: ["Bank Account(s)", "Add Bank Account"],
    domText: [
      "Add Bank Account",
      "Unbind",
      "Modifying Bank Cards",
      "Cancel",
      "Cue",
      "Unbind your bank card？",
      "Tips:Only your own bank account is accepted",
      "The next step",
      "Please complete the account first",
      "Modified successfully",
      "Added successfully",
      "Bank Holder",
      "Bank Account Certificate",
      "Note: Please upload a bank card or statement containing the account holder's name and bank account number."
    ],
    fields: ["Bank Name", "Bank Account Number", "Supported Currency(Multiple selection)"],
    placeholderText: [
      "Fill in full bank name",
      "Please enter",
      "If yes, please fill in",
      "e.g.Bank of China (Headquarters)"
    ],
    btnText: 'Confirm',
    accountTipText: "Account Number Instructions",
    bankNamePlaceholder: "Please enter the bank name"
  },
  // 公告
  notice: {
    pageTitle: "Bulletin",
    noticePublicText: "Publish time",
    domText: "No content in the announcement",
    loadingText: "PDF Loading"
  },
  // 隐私政策
  policy: {
    pageTitle: "Personal Data (Privacy) Policy Privacy Policy Statement"
  },
  // 组件
  myComponent: {
    domText: "Failed, refunds",
    typeText: ["Deposit", "Withdraw", "Payment"],
    statusText: [
      "Pending",
      "Processing success",
      "Processing failure",
      "Automatic processing",
      "Refund to account",
	  "Canceled"
    ],
    accountTypeText: ["Accounts A", "Accounts B"],
	dialogBtText:["Not canceled","Confirm"],
	dialogText:"Do you want to cancel the cash order?",
  dialogText1:"Do you want to cancel the deposit order?",
	cancelBtn:"Cancel Order"
  },
  // 公共
  public: {
    contentText: [
      "No more.",
      "No data available",
      "Parameter error",
      "Please select",
      "Loading",
      "Load failed, tap the screen to try again",
      "Data load failed, click ",
      "reload"
    ]
  },
  poorNetwork: "Network instability, data updates may be delayed"
};
